<template>
  <div class="height-all refer-music-list">
    <div class="height-all refer-music-list-main flex-column">
      <div
        class="add-music-reference-filter"
        v-if="createRenderType != 'mobile'"
      >
        <div class="add-music-reference-filter-item fn-inline">
          <Select
            v-model="renderData.styleTagValue"
            @change="handleSelectStyle"
            :clearable="true"
            :placeholder="$$t('create.genre')"
            :options="getEnOptions(ReferStyleLabelData.list)"
          ></Select>
        </div>
        <div class="add-music-reference-filter-item fn-inline">
          <Select
            v-model="renderData.moodTagValue"
            @change="handleSelectMood"
            :clearable="true"
            :placeholder="$$t('create.mood')"
            :options="getEnOptions(ReferEmotionalLabelData.list)"
          ></Select>
        </div>
      </div>
      <div
        class="add-music-reference-filter-mobile"
        v-if="createRenderType == 'mobile'"
      >
        <ul class="add-music-reference-filter-mobile-item fn-inline">
          <template
            v-for="(item, index) in getEnOptions(ReferStyleLabelData.list)"
            :key="`${index}__${item.label}`"
          >
            <li
              class="filter-item fn-inline"
              @click="
                () => {
                  if (renderData.styleTagValue?.value == item.value) {
                    handleSelectStyle(null);
                  } else {
                    handleSelectStyle(item);
                  }
                }
              "
              :class="{
                'filter-item-active':
                  renderData.styleTagValue?.value == item.value,
              }"
            >
              {{ item.label }}
            </li>
          </template>
        </ul>
        <ul class="add-music-reference-filter-mobile-item fn-inline">
          <template
            v-for="(item, index) in getEnOptions(ReferEmotionalLabelData.list)"
            :key="`${index}__${item.label}`"
          >
            <li
              class="filter-item fn-inline"
              @click="
                () => {
                  if (renderData.moodTagValue?.value == item.value) {
                    handleSelectMood(null);
                  } else {
                    handleSelectMood(item);
                  }
                }
              "
              :class="{
                'filter-item-active':
                  renderData.moodTagValue?.value == item.value,
              }"
            >
              {{ item.label }}
            </li>
          </template>
        </ul>
      </div>
      <div class="refer-music-list-box height-0 flex1">
        <QueryEmptyRetry
          :loading="renderData.initLoading"
          v-if="renderData.loadError || renderData.initLoading"
          @retry="
            () => {
              doRetry(true);
            }
          "
        ></QueryEmptyRetry>
        <PullTo
          v-else
          itemIdField="id"
          :datas="renderData.referDatas"
          v-model:refreshing="renderData.refreshing"
          v-model:loadingMore="renderData.loadingMore"
          v-model:isLoading="renderData.isLoading"
          v-model:finished="renderData.finished"
          @refresh="doRefresh"
          @loadMore="doLoadMore"
        >
          <template v-slot:default="slotProps">
            <div class="refer-music-item">
              <ReferMusicItem
                audioUrlSuffix="?type=refer_list_tab=0"
                :item="slotProps.item"
                :index="slotProps.index"
                :tabCode="1"
                @apply="doApply"
                @cancel="doCancel"
                @more="doMore"
              >
              </ReferMusicItem>
            </div>
          </template>
        </PullTo>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
} from "vue";
import QueryEmptyRetry from "@/components/basic/pullTo/queryEmptyRetry.vue";
import PullTo from "@/components/basic/pullTo/PullTo.vue";
import { useRouter, useRoute } from "vue-router";
import ReferMusicItem from "./referenceItem.vue";

import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);

import userReferMusicStore, {
  TabDataSuffixMap,
} from "@/store/create/referMusicStore.js";

import Select from "@/components/basic/select/Select.vue";
import {
  ReferStyleLabelData,
  ReferEmotionalLabelData,
  getEnOptions,
} from "@/config/const.js";
import { $$t } from "@/i18n/i18n.js";

const referMusicStore = userReferMusicStore();
const Router = useRouter();
const route = useRoute();

const props = defineProps({
  filterOpenState: {
    type: Boolean,
    default: false,
  },
  isCurShow: {
    type: Boolean,
    default: false,
  },
});
const emits = defineEmits([
  "update:filterOpenState",
  "apply",
  "cancel",
  "more",
]);
const renderData = reactive({
  filterOpenState: false,
  moodTagValue: null, // JSON.parse(localStorage.getItem("moodValue")) || null,
  styleTagValue: null, // JSON.parse(localStorage.getItem("styleValue")) || null,
  referDatas: [],
  refreshing: false,
  loadingMore: false,
  isLoading: false,
  loadError: false,
  finished: false,
  filterParams: {
    query_type: 1,
  },
  initLoading: false,
});

const onStyleTagChange = (value) => {
  renderData.styleTagValue = value;
};
const doRefresh = (done, errodone) => {
  renderData.isLoading = true;
  referMusicStore.refresh(
    getQueryParams(),
    (...args) => {
      renderData.finished = args[1] ?? true;
      renderData.isLoading = false;
      renderData.loadError = false;
      done(...args);
    },
    (...args) => {
      renderData.isLoading = false;
      renderData.loadError = true;
      errodone(...args);
    }
  );
};

const doLoadMore = (done, errodone) => {
  renderData.isLoading = true;
  referMusicStore.loadMore(
    getQueryParams(),
    (...args) => {
      renderData.finished = args[1] ?? true;
      renderData.isLoading = false;
      done(...args);
    },
    (...args) => {
      renderData.isLoading = false;
      errodone(...args);
    }
  );
};

const doRetry = (isRetry) => {
  if (!isRetry) {
    renderData.initLoading = true;
  }
  renderData.isLoading = true;
  referMusicStore.init(
    getQueryParams(),
    (...args) => {
      renderData.isLoading = false;
      renderData.finished = args[1] ?? true;
      renderData.loadError = false;
      renderData.initLoading = false;
    },
    (...args) => {
      renderData.isLoading = false;
      renderData.loadError = true;
      renderData.initLoading = false;
    }
  );
  true, isRetry;
};

// const handleFilterClose = () => {
//   renderData.filterOpenState = false;
//   if (renderData.filterParams.mood != renderData.moodTagValue?.en) {
//     init();
//   }
// };

// const handleFilterCancel = () => {
//   if (renderData.filterParams.mood != renderData.moodTagValue?.en) {
//     init();
//   }
// };

const handleSelectStyle = (item) => {
  renderData.styleTagValue = item;
  referMusicStore.setFilterAllData({
    moodTagValue: renderData.moodTagValue, // JSON.parse(localStorage.getItem("moodValue")) || null,
    styleTagValue: renderData.styleTagValue,
  });
  // localStorage.setItem("styleValue", JSON.stringify(renderData.styleTagValue));
  init(true);
};

const handleSelectMood = (item) => {
  renderData.moodTagValue = item;
  referMusicStore.setFilterAllData({
    moodTagValue: renderData.moodTagValue, // JSON.parse(localStorage.getItem("moodValue")) || null,
    styleTagValue: renderData.styleTagValue,
  });
  // localStorage.setItem("moodValue", JSON.stringify(renderData.moodTagValue));
  init(true);
};

const getQueryParams = () => {
  renderData.filterParams = {
    query_type: 1,
    mood: renderData.moodTagValue?.value ?? null,
    genre: renderData.styleTagValue?.value ?? null,
  };
  return renderData.filterParams;
};

const doApply = (item) => {
  emits("apply", item, 1);
};

const doCancel = (item) => {
  emits("cancel", item, 1);
};

const doMore = (item) => {
  emits("more", item, 1);
};

watch(
  () => props.filterOpenState,
  (newVal, oldVal) => {
    renderData.filterOpenState = props.filterOpenState;
  }
);

watch(
  () => renderData.filterOpenState,
  (newVal, oldVal) => {
    emits("update:filterOpenState", newVal);
  }
);

watch(
  () => referMusicStore.datas_all,
  (newVal, oldVal) => {
    renderData.referDatas = referMusicStore.datas_all;
  }
);

watch(
  () => props.isCurShow,
  (newVal, oldVal) => {
    if (
      props.isCurShow &&
      !referMusicStore[
        `hasInit_${TabDataSuffixMap[getQueryParams().query_type]}`
      ]
    ) {
      doRetry();
    }
  }
);

const init = (isSelect) => {
  renderData.moodTagValue = referMusicStore.filterAllData?.moodTagValue;
  renderData.styleTagValue = referMusicStore.filterAllData?.styleTagValue;
  if (referMusicStore.datas_all?.length && !isSelect) {
    renderData.referDatas = referMusicStore.datas_all;
    renderData.initLoading = false;
  } else {
    doRetry();
  }
};

onMounted(() => {
  init();
});
</script>
<style lang="scss">
.refer-music-list {
  .add-music-reference-filter {
    height: 30px;
    margin: 0 40px 10px 40px;
    .add-music-reference-filter-item {
      width: 140px;
      height: 30px;
      margin-right: 8px;
    }
  }
  .add-music-reference-filter-mobile {
    background: rgba(255, 255, 255, 0.05);
    padding: 8px 0;
    margin: 0 0 4px 0;
    .add-music-reference-filter-mobile-item {
      overflow-x: auto;
      white-space: nowrap;
      max-width: calc(100% - 48px);
      width: 100%;
      margin: 0 24px;
      text-transform: capitalize;
      &:not(:first-child) {
        margin-top: 6px;
      }
    }
    .filter-item {
      height: 30px;
      border-radius: 8px;
      opacity: 1;
      align-items: center;
      padding: 0 20px;
      line-height: 30px;
      font-family: PingFang SC;
      font-size: 14px;
      font-weight: normal;
      color: #ffffff;
      &:not(:first-child) {
        margin: 0 0 0 4px;
      }
      &:first-child {
        margin: 0 0 0 16px;
      }
      &:last-child {
        margin: 0 16px 0 0;
      }
      &.filter-item-active {
        background: rgba(148, 173, 255, 0.3);
      }
    }
  }
  .refer-music-list-main {
    flex-direction: column;
    .style-music {
      padding: 16px 0 16px 16px;
      background: #edeff1;
      .mt {
        margin-top: 12px;
      }
      .style-music-box {
        // flex-wrap: wrap;
        overflow-y: scroll;
        white-space: nowrap;
      }
      .style-music-item {
        width: max-content;
        border-radius: 12px 12px 12px 12px;
        padding: 6px 17px;
        margin-right: 4px;
        font-weight: 400;
        font-size: 14px;
        color: #000000;
      }
      .style-music-item-active {
        background: rgba(0, 87, 255, 0.1);
        font-weight: 500;
        color: #0057ff;
      }
    }
  }
  .refer-music-list-box {
  }
}
</style>
